import {
    ChapterType,
    IQuotationBlock,
    IQuotationCost,
    IQuotationRetail,
    IQuotationSection,
    IQuotationTraveller,
    IQuotationTravellerPrice
} from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { IQuotationVat } from "libraries/service/resources/quotation-quotations/quotation-quotations-resource.service";


export enum TableRowType {
    totalHeader = "totalHeader",
    adjustmentHeader = "adjustmentHeader",
    chapterHeader = "chapterHeader",
    blockData = "blockData",
}

export interface ITableRow {
    type?: TableRowType;
    title?: string;
    total?: IQuotationCost;
    totalRetail?: IQuotationRetail;
    totalVat?: IQuotationVat;
    totalRetailIncludingVat?: IQuotationCost;
    travellers?: IQuotationTraveller[];
    chapter?: ITableChapter;
    block?: ITableBlock;
    chapterType?: ChapterType;
}

export interface ITableHeaders {
    title: string;
    total: string;
    margin?: string;
    gain?: string;
    commission?: string;
    commissionTotal?: string;
    retailTotal?: string;
    travellers?: IQuotationTraveller[];
    vat?: string;
}

export interface ITableChapter {
    type: ChapterType;
    sections?: IQuotationSection[];
}

export interface ITableBlock extends IQuotationBlock {
    isFirstSectionBlockWithCost?: boolean;
    isFirstSectionBlock?: boolean;
    quotationOffset?: number;
    sectionLength?: number;
    blockWithCostQuantity?: number;
    isEmpty?: boolean;
    day?: string;
    isChapo?: boolean;
    travellerPrices?: IQuotationTravellerPrice[];
}

